
import { defineComponent, ref, inject } from 'vue'

export default defineComponent({
    setup() {
        const dialogTeamColor = inject('dialogTeamColor')

        return {
            dialogTeamColor
        }
        
    },
})
